import * as React from 'react';
import { mapPathToName, mapPathToLabel } from '../../../app/mappers'
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {
    Link as RouterLink,
    useLocation,
} from 'react-router';
import Link, { LinkProps } from '@mui/material/Link';
import { t } from "@lingui/core/macro";

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={RouterLink as any} />;
}

const RouterBreadcrumbs = () => {
    const location = useLocation();
    const pathnames: string[] = location.pathname.split('/').filter((x) => x);

    return (
        <Breadcrumbs aria-label="breadcrumb" data-testid="breadcrumb" separator="›">
            {pathnames.map((value, index) => {
                const last = index === pathnames.length - 1;
                const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                const previous = index > 0 ? pathnames[index - 1] : undefined;

                const name = mapPathToName(previous, value)
                const label = mapPathToLabel(value)

                if ('edit' === value) {
                    value = t`Edit`
                } else if ('add' === value) {
                    value = t`Add`
                }

                return last ? (
                    <Typography key={to} sx={{ color: 'text.secondary' }}>
                        {name || label || value}
                    </Typography>
                ) : (
                    <LinkRouter
                        underline="hover"
                        color="inherit"
                        viewTransition={true}
                        to={to} key={to}>
                        {name || label || value}
                    </LinkRouter>
                );
            })}
        </Breadcrumbs>
    );
}

export default RouterBreadcrumbs
